import React, { useState, useEffect } from "react";
import UploadedBanner from "../../../components/common/UploadBanner";
import { InputField } from "../../../components/common/InputField";
import { SelectField } from "../../../components/common/SelectField";
import ModalHeader from "../../../components/ui/ModalHeader";
import { AddNewRecipieInput } from "../../../config/addNewRecipie";
import { useMediaStore } from "../../../store";
import { SearchableSelectField } from "../../../components/common/SearchableSelectField";

const AddNewRecipeOverViewModal = ({
                                     jsonData,
                                     onClose,
                                     onSubmit,
                                     selectedPlanId,
                                     handleImageUrlChange,
                                   }) => {
  const { imageUrls: mediaData} = useMediaStore();
  // const [,setImageOptions] = useState([]);
  const recipe = jsonData?.recipe || {};
  const {
    name = "",
    description = "",
    cooking_time_minutes = "",
    cover_image_url = "",
    servings = "",
    difficulty_level = "",
    nutrition = { protein_g: 0, carbs_g: 0, fat_g: 0 },
    instructions = [],
    ingredients = [],
    category = "",
  } = recipe;
  const [formData, setFormData] = useState({
    recipeName: name,
    description: description,
    duration: cooking_time_minutes,
    servings,
    difficulty: difficulty_level,
    nutrition: `Protein: ${nutrition.protein_g}g, Carbs: ${nutrition.carbs_g}g, Fat: ${nutrition.fat_g}g`,
    instructions: instructions.join("\n"),
    ingredients: ingredients
      .map((ing) => `${ing.quantity} ${ing.name}`)
      .join(", "),
    bannerImageUrl: cover_image_url,
    category: category,
  });

  useEffect(() => {
    setFormData({
      recipeName: name,
      description: description,
      duration: cooking_time_minutes,
      servings,
      difficulty: difficulty_level,
      nutrition: `Protein: ${nutrition.protein_g}g, Carbs: ${nutrition.carbs_g}g, Fat: ${nutrition.fat_g}g`,
      instructions: instructions.join("\n"),
      ingredients: ingredients
        .map((ing) => `${ing.quantity} ${ing.name}`)
        .join(", "),
      bannerImageUrl: cover_image_url,
      category: category,
    });
  }, [category, cooking_time_minutes, cover_image_url, description, difficulty_level, ingredients, instructions, jsonData, name, nutrition.carbs_g, nutrition.fat_g, nutrition.protein_g, servings]);

  // useEffect(() => {
  //   const fetchMediaSources = async () => {
  //     try {
  //       const cdnUrls = mediaData.map((item) => item.cdnUrl);
  //       setImageOptions(cdnUrls);
  //     } catch (error) {
  //       console.error("Error fetching media sources:", error);
  //     }
  //   };

  //   fetchMediaSources().then();
  // }, [mediaData, setImageOptions]);
  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    if (key === "bannerImageUrl") {
      handleImageUrlChange(value);
    }
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: "block" }}
        aria-modal="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <ModalHeader onClose={onClose} />
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-2"></div>
                <div className="col-sm-6">
                  <h5>RECIPE OVERVIEW</h5>
                  <hr />
                  {AddNewRecipieInput?.reduce((rows, field, index) => {
                    if (field.type === "textarea") {
                      rows.push([field]);
                    } else {
                      const isEvenIndex = index % 2 === 0;
                      if (isEvenIndex) {
                        rows.push([field]);
                      } else {
                        rows[rows.length - 1].push(field);
                      }
                    }
                    return rows;
                  }, []).map((row, rowIndex) => (
                    <div className="row mb-3" key={rowIndex}>
                      {row.map((field, index) => (
                        <div
                          className={
                            field.type === "textarea" ? "col-12" : "col-6"
                          }
                          key={index}
                        >
                          {field.type === "select" ? (
                            <SelectField
                              label={field.label}
                              id={field.id}
                              options={field.options}
                              value={formData[field.valueKey]}
                              onChange={(e) =>
                                handleInputChange(
                                  field.valueKey,
                                  e.target.value
                                )
                              }
                              disabled={true}
                            />
                          ) : field.type === "textarea" ? (
                            <div className="mb-3">
                              <label htmlFor={field.id} className="form-label">
                                {field.label}
                              </label>
                              <textarea
                                className="form-control"
                                id={field.id}
                                rows={field.rows}
                                value={formData[field.valueKey]}
                                onChange={(e) =>
                                  handleInputChange(
                                    field.valueKey,
                                    e.target.value
                                  )
                                }
                                disabled={true}
                              />
                            </div>
                          ) : (
                            <InputField
                              label={field.label}
                              type={field.type}
                              id={field.id}
                              value={formData[field.valueKey]}
                              onChange={(e) =>
                                handleInputChange(
                                  field.valueKey,
                                  e.target.value
                                )
                              }
                              disabled={true}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
                <div className="col-sm-4">

                  <SearchableSelectField
                    key={'image'}
                    label={'Image Name'}
                    id={'bannerImageUrl'}
                    options={
                      mediaData
                    }
                    value={formData['bannerImageUrl']}
                    onChange={(value) =>
                      handleInputChange("bannerImageUrl", value)
                    }
                  />


                  <UploadedBanner
                    defaultImage={formData.bannerImageUrl}
                    onImageChange={(url) =>
                      handleInputChange("bannerImageUrl", url)
                    }
                  />
                </div>
              </div>
            </div>
            {!selectedPlanId ? (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Save & Next
                </button>
              </div>
            ) : (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default AddNewRecipeOverViewModal;
